import { render, staticRenderFns } from "./SelectFacultyPosition.vue?vue&type=template&id=e70b4890&"
import script from "./SelectFacultyPosition.vue?vue&type=script&lang=js&"
export * from "./SelectFacultyPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports